<template>
    <div>
        <CModal
                add-content-classes="bg-transparent border-0"
                :no-close-on-backdrop="true"
                :centered="true"
                :show.sync="openComplete"
                :closeOnBackdrop="false"
        >
            <template #header-wrapper>
                <div class="closeBtnContainer" @click="loginModal=false">
                    <p class="closeButton">
                        <img src="@/assets/icons/closeButton.svg" style="background-color: white; border-radius: 50%;" @click="closeAllModal">
                    </p>
                </div>
            </template>
            <template #body-wrapper>
                <div class="completeContainer">
                    <CCol style="align-items: center">
                        <CRow class="title">
                            <label>COMPLETE!</label>
                        </CRow>
                        <CRow class="content">
                            <label>Changing your e-mail is completed</label>
                        </CRow>
                        <CRow class="completeButton">
                            <CButton color="success" style="border-radius: 24px;width: 40%" @click="closeAllModal">OK</CButton>
                        </CRow>
                    </CCol>
                </div>
            </template>
            <template #footer-wrapper>
                <div/>
            </template>
        </CModal>
    </div>
</template>

<script>
    export default {
        name: "complete",
        props:{
            openComplete:Boolean,
        },
    }
</script>

<style scoped>
    .closeBtnContainer{
        padding-right: 1rem;
    }

    .closeButton {
        align-content: flex-end;
        float: right;
        width: 26px;
        height: 26px;
        padding-top: -100px;
        margin-right: 12px;
        cursor: pointer;
        margin-bottom: 0.1em;
    }

    .completeContainer {
        width: 80%;
        border-radius: 20px;
        background-color: white;
        padding-top: 1.75rem;
        padding-bottom: 1.75rem;
        align-self: center;
    }

    .title {
        color: black;
        justify-content: center;
        font-family: Roboto;
        margin-bottom: 0.8rem;
        font-size: 1.28rem;
    }

    .content {
        color: black;
        justify-content: center;
        font-family: "Roboto Light";
        font-size: 0.9rem;
        margin-bottom: 1.4rem;
    }

    .completeButton {
        justify-content: center;
    }

</style>